// Pack To The Future custom behaviour.

// Desktop menu: line each dropdown up under the menu item that opened it,
// without letting it run off the right-hand edge.
(() => {
  const desktop = window.matchMedia('(min-width: 990px)');

  const place = (item) => {
    const list = item.querySelector('.menu-list__submenu .mega-menu__list');
    if (!list || !desktop.matches) return;
    const container = list.parentElement;
    const offset = item.getBoundingClientRect().left - container.getBoundingClientRect().left;
    const maxOffset = container.clientWidth - list.offsetWidth;
    list.style.setProperty('--ptf-menu-offset', `${Math.max(0, Math.min(offset, maxOffset))}px`);
  };

  document.addEventListener('pointerover', (event) => {
    const item = event.target.closest?.('.menu-list__list-item');
    if (item) place(item);
  });

  document.addEventListener('focusin', (event) => {
    const item = event.target.closest?.('.menu-list__list-item');
    if (item) place(item);
  });
})();

// Mobile menu row: add arrows that show when there is more to scroll to.
(() => {
  const chevron = (direction) =>
    `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="${
      direction === 'prev' ? 'M14.5 6l-6 6 6 6' : 'M9.5 6l6 6-6 6'
    }"/></svg>`;

  const setup = (bar) => {
    const scroller = bar.querySelector('.menu-list__scroll-container');
    if (!scroller || bar.querySelector('.ptf-scroll-arrow')) return;

    const buttons = ['prev', 'next'].map((direction) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = `ptf-scroll-arrow ptf-scroll-arrow--${direction}`;
      button.setAttribute('aria-label', direction === 'prev' ? 'Scroll menu left' : 'Scroll menu right');
      button.innerHTML = chevron(direction);
      button.hidden = true;
      button.addEventListener('click', () => {
        const distance = scroller.clientWidth * 0.7 * (direction === 'prev' ? -1 : 1);
        scroller.scrollBy({ left: distance, behavior: 'smooth' });
      });
      bar.append(button);
      return button;
    });

    const update = () => {
      const max = scroller.scrollWidth - scroller.clientWidth;
      buttons[0].hidden = scroller.scrollLeft <= 4;
      buttons[1].hidden = scroller.scrollLeft >= max - 4;
      bar.classList.toggle('ptf-can-prev', !buttons[0].hidden);
      bar.classList.toggle('ptf-can-next', !buttons[1].hidden);
    };

    scroller.addEventListener('scroll', update, { passive: true });
    new ResizeObserver(update).observe(scroller);
    update();
  };

  const init = () => document.querySelectorAll('.menu-list--mobile').forEach(setup);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // The header can be re-rendered by the theme; re-attach arrows if that happens.
  let queued = false;
  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      init();
    });
  }).observe(document.body, { childList: true, subtree: true });
})();

// Mobile menu row: items with no page of their own (e.g. "More") open the menu drawer with
// that item's section expanded, instead of going nowhere.
(() => {
  document.addEventListener('click', (event) => {
    const link = event.target.closest?.('[data-ptf-drawer-section]');
    if (!link) return;
    event.preventDefault();
    const drawer = document.getElementById('Details-menu-drawer-container');
    const section = document.getElementById(`Details-menu-drawer-${link.dataset.ptfDrawerSection}`);
    if (!drawer) return;
    if (!drawer.open) drawer.querySelector(':scope > summary')?.click();
    setTimeout(() => {
      if (!section) return;
      if (!section.open) section.querySelector(':scope > summary')?.click();
      setTimeout(() => section.scrollIntoView({ block: 'nearest', behavior: 'smooth' }), 250);
    }, 300);
  });
})();
